/**
 * Standard rich text editor (Quill) — used for question text, explanations, lesson content.
 * Images pasted or inserted from the toolbar are embedded inline (data URLs), so a figure travels
 * with the question wherever it is rendered.
 *
 *   <RichTextEditor value onChange placeholder minHeight={120} compact testid />
 */
import React, { useMemo } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const FULL_TOOLBAR = [
  [{ header: [1, 2, 3, false] }],
  ['bold', 'italic', 'underline', 'strike'],
  [{ script: 'sub' }, { script: 'super' }],
  [{ color: [] }, { background: [] }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ align: [] }],
  ['blockquote', 'code-block'],
  ['link', 'image'],
  ['clean'],
];
const COMPACT_TOOLBAR = [
  ['bold', 'italic', 'underline'],
  [{ script: 'sub' }, { script: 'super' }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['link', 'image'],
  ['clean'],
];
export const RICH_FORMATS = ['header', 'bold', 'italic', 'underline', 'strike', 'script', 'color', 'background', 'list', 'align', 'blockquote', 'code-block', 'link', 'image'];

export default function RichTextEditor({ value, onChange, placeholder, minHeight = 120, compact = false, readOnly = false, testid, className = '' }) {
  const modules = useMemo(() => ({ toolbar: compact ? COMPACT_TOOLBAR : FULL_TOOLBAR }), [compact]);
  return (
    <div className={`rich-editor border border-input rounded bg-white overflow-hidden focus-within:border-shell-primary focus-within:ring-1 focus-within:ring-shell-primary/40 ${className}`} data-testid={testid}>
      <ReactQuill
        theme="snow"
        value={value || ''}
        onChange={(html) => onChange?.(html === '<p><br></p>' ? '' : html)}
        modules={modules}
        formats={RICH_FORMATS}
        placeholder={placeholder}
        readOnly={readOnly}
        style={{ minHeight }}
      />
    </div>
  );
}
